export default __webpack_public_path__ + "static/heads-ud-trucks-3609769051b47ed2313dc8a1a22ffbf1.png";